import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { makeStyles, Theme } from '@material-ui/core';

interface Props {
  filteredRemoteModerators: any;
}

export const RemoteModeratorList = ({ filteredRemoteModerators }: Props) => {
  const classes = useStyles({});

  return (
    <div>
      <div className={classes.title}>
        <FormattedMessage
          id="components.inCall.participantList.remoteModeratorLabel"
          defaultMessage={'Remote Moderators:'}
        />
      </div>
      {filteredRemoteModerators.length ? (
        filteredRemoteModerators.map((m, index) => (
          <p data-testid="remoteModerator" key={`remoteModerator-${index}`}>
            {m.displayName}
          </p>
        ))
      ) : (
        <p data-testid="remoteModerator">
          <FormattedMessage
            id="components.inCall.participantList.noSearchResultsRemoteModerators"
            defaultMessage={'No remote moderators matched your search'}
          />
        </p>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontWeight: theme.typography.fontWeightBold
  }
}));

export default injectIntl(RemoteModeratorList);
